// extracted by mini-css-extract-plugin
export default {"location":"location___nEUIi","address":"address___FqSA7","address_text":"address_text___cLGii","map":"map___tNP4b","email":"email___mIy0A"};